export const STYLES = {
  fontFamily: "'Rubik', sans-serif",
  colors: {
    primary: "#010101",
    accent: "#71b5dc",
    discount: "#dab99a",
    secondary: "#7f8c8d",
    warning: "#dc8f38",
  },
  spacing: {
    drawerPadding: { xs: 2, sm: 4 },
    itemGap: 2,
    sectionMargin: 3,
  },
} as const;














